import './Nss.css';
import api from '../../../../api';
import NSSContent from './Partials/NssContent';
import React, { useState, useEffect } from 'react';
import DynamicBanner from '../../include/DynamicBanner';

const Nss = () => {
const [nssData, setNssData] = useState(null);
const [isLoading, setIsLoading] = useState(true);
const [error, setError] = useState(null);

useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get("/api/sitepages/about-us/nss-activities");
                setNssData(response.data); 
                setIsLoading(false);
            } catch (err) {
                console.error("Error fetching NSS data:", err);
                setError("Failed to load NSS activities. Please try again.");
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    if (isLoading || error || !nssData) {
        return null; 
    }

    const bannerData = nssData.banner_data || {};
    const contentBlocks = nssData.content_blocks || [];
    const mainTabs = nssData.main_tabs || [];

    const bannerTitle = bannerData.title || "NATIONAL SERVICE SCHEME (NSS)";
    const bannerImage =Array.isArray(bannerData.images) && bannerData.images.length > 0? bannerData.images[0]: '';
    const mobimg =Array.isArray(bannerData.mobile_images) && bannerData.mobile_images.length > 0? bannerData.mobile_images: [];


    
    return (
        <div className="nss-page">
            <DynamicBanner title={bannerTitle} bgImage={bannerImage}  bgImageMobile={mobimg}/>
            <NSSContent 
                contentBlocks={contentBlocks} 
                mainTabs={mainTabs} 
            />
        </div>
    );
};

export default Nss;